export { renderRating_unstable as renderRating } from '@fluentui/react-rating';
